import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "block",
  for: "firstName"
}
const _hoisted_2 = {
  class: "block",
  for: "lastName"
}
const _hoisted_3 = {
  class: "block",
  for: "email"
}
const _hoisted_4 = {
  class: "block",
  for: "password"
}
const _hoisted_5 = {
  class: "block",
  for: "access"
}
const _hoisted_6 = { id: "access" }
const _hoisted_7 = { class: "flex justify-end gap-2" }

import PDropdown from "primevue/dropdown";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import PPassword from "primevue/password";
import CButton from "@/components/Button.vue";
import PInputText from "primevue/inputtext";
import { ref, computed, onBeforeMount } from "vue";
import { cloneDeep } from "lodash";
import { useVuelidate } from "@vuelidate/core";
import FormErrors from "@/components/FormErrors.vue";
import { useStore } from "vuex";
import { useI18n } from "vue-i18n";

export default /*#__PURE__*/_defineComponent({
  __name: 'TeamMemberForm',
  props: {
  teamMember: {
    type: Object,
    default: () => ({}),
  },
  isUpdate: {
    type: Boolean,
    default: false,
  },
},
  emits: ["cancel", "save"],
  setup(__props, { emit }) {

const props = __props;

const { t } = useI18n();
const posList = computed(() => {
  return store.getters["tenant/info"]?.posList ?? [];
});


const store = useStore();



const newTeamMemberRules = store.getters["teamMember/rulesToCreateATeamMember"];

let teamMember = ref({});
let teamMemberV$: any;
const roles = computed(() =>
  (store.getters["tenant/roles"] ?? []).map((role: string) => ({
    id: role,
    name: t(role),
  }))
);
const resetTeamMember = () => {
  teamMember.value = {};
};

const init = () => {
  teamMemberV$ = useVuelidate(newTeamMemberRules, teamMember, {
    $lazy: true,
  });
  teamMember.value = props.isUpdate
    ? cloneDeep(props.teamMember)
    : { posAccess: {} };
  teamMemberV$.value.$reset();
};

onBeforeMount(() => {
  init();
});

const save = async () => {
  const isNewTeamMemberValid = await teamMemberV$.value.$validate();
  if (isNewTeamMemberValid) {
    emit("save", cloneDeep(teamMember.value));
  }
};

const cancel = () => {
  init();
  emit("cancel");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", {
    class: "flex flex-col gap-y-4",
    onSubmit: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["prevent"]))
  }, [
    _createElementVNode("div", null, [
      _createElementVNode("label", _hoisted_1, _toDisplayString(_ctx.$t("firstName")), 1),
      _createVNode(_unref(PInputText), {
        class: _normalizeClass(["w-full", { 'p-invalid': _unref(teamMemberV$).firstName.$invalid }]),
        id: "firstName",
        type: "text",
        modelValue: _unref(teamMemberV$).firstName.$model,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(teamMemberV$).firstName.$model) = $event)),
        autocomplete: "off"
      }, null, 8, ["modelValue", "class"]),
      _createVNode(FormErrors, {
        errors: _unref(teamMemberV$).firstName.$errors
      }, null, 8, ["errors"])
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("label", _hoisted_2, _toDisplayString(_ctx.$t("lastName")), 1),
      _createVNode(_unref(PInputText), {
        class: _normalizeClass(["w-full", { 'p-invalid': _unref(teamMemberV$).lastName.$invalid }]),
        id: "lastName",
        type: "text",
        modelValue: _unref(teamMemberV$).lastName.$model,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(teamMemberV$).lastName.$model) = $event)),
        autocomplete: "off"
      }, null, 8, ["modelValue", "class"]),
      _createVNode(FormErrors, {
        errors: _unref(teamMemberV$).lastName.$errors
      }, null, 8, ["errors"])
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("label", _hoisted_3, _toDisplayString(_ctx.$t("email")), 1),
      _createVNode(_unref(PInputText), {
        class: _normalizeClass(["w-full", { 'p-invalid': _unref(teamMemberV$).username.$invalid }]),
        id: "email",
        type: "text",
        modelValue: _unref(teamMemberV$).username.$model,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(teamMemberV$).username.$model) = $event)),
        autocomplete: "off"
      }, null, 8, ["modelValue", "class"]),
      _createVNode(FormErrors, {
        errors: _unref(teamMemberV$).lastName.$errors
      }, null, 8, ["errors"])
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("label", _hoisted_4, _toDisplayString(_ctx.$t("password")), 1),
      _createVNode(_unref(PPassword), {
        class: "w-full",
        "input-props": { autocomplete: 'new-password' },
        modelValue: _unref(teamMemberV$).password.$model,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(teamMemberV$).password.$model) = $event)),
        type: "password",
        id: "password",
        feedback: false,
        "toggle-mask": ""
      }, null, 8, ["modelValue"]),
      _createVNode(FormErrors, {
        errors: _unref(teamMemberV$).password.$errors
      }, null, 8, ["errors"])
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("label", _hoisted_5, _toDisplayString(_ctx.$t("access")), 1),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_unref(DataTable), {
          value: _unref(posList),
          responsiveLayout: "stack",
          breakpoint: "650px"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(Column), {
              field: "name",
              header: _ctx.$t('name')
            }, null, 8, ["header"]),
            _createVNode(_unref(Column), {
              header: _ctx.$t('access')
            }, {
              body: _withCtx(({ data }) => [
                _createVNode(_unref(PDropdown), {
                  placeholder: _ctx.$t('none'),
                  class: "w-full",
                  showClear: "",
                  "option-label": "name",
                  "option-value": "id",
                  "data-key": "id",
                  options: _unref(roles),
                  modelValue: _unref(teamMember).posAccess[data.id],
                  "onUpdate:modelValue": ($event: any) => ((_unref(teamMember).posAccess[data.id]) = $event)
                }, null, 8, ["placeholder", "options", "modelValue", "onUpdate:modelValue"])
              ]),
              _: 1
            }, 8, ["header"])
          ]),
          _: 1
        }, 8, ["value"])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(CButton, {
        class: "p-button-xs p-button-success",
        onClick: _cache[4] || (_cache[4] = ($event: any) => (save()))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("save")), 1)
        ]),
        _: 1
      }),
      _createVNode(CButton, {
        class: "p-button-xs p-button-danger",
        onClick: _cache[5] || (_cache[5] = ($event: any) => (cancel()))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("cancel")), 1)
        ]),
        _: 1
      })
    ])
  ], 32))
}
}

})